<script setup lang="ts">
import { computed } from 'vue';
import Dialog from 'primevue/dialog';
import { useConfirm } from '@/composables/useConfirm';

const { state, answer } = useConfirm();

const visible = computed({
  get: () => state.value !== null,
  set: (v: boolean) => { if (!v) answer(false); },
});
</script>

<template>
  <Dialog :visible="visible" @update:visible="visible = $event" modal dismissable-mask :style="{ width: '420px' }"
          :pt="{ pcCloseButton: { root: { tabindex: -1 } } }">
    <template #header>
      <h2 class="display-md">{{ state?.title }}</h2>
    </template>

    <div class="body">
      <p class="msg">{{ state?.message }}</p>
      <p v-if="state?.details" class="details">{{ state.details }}</p>
    </div>

    <template #footer>
      <button class="btn-text" @click="answer(false)">{{ state?.cancelLabel ?? 'Cancel' }}</button>
      <button :class="['btn-confirm', { danger: state?.danger }]" @click="answer(true)" autofocus>
        {{ state?.confirmLabel ?? 'Confirm' }}
      </button>
    </template>
  </Dialog>
</template>

<style scoped>
.body { display: flex; flex-direction: column; gap: 12px; }
.msg { font-size: 14px; line-height: 1.6; color: var(--on-surface); margin: 0; }
.details { font-size: 12px; line-height: 1.5; color: var(--on-surface-variant); margin: 0; font-style: italic; }


.btn-confirm {
  background: var(--primary); color: var(--on-primary);
  padding: 10px 20px; border: 1px solid var(--primary);
  font-family: 'Inter', sans-serif; font-size: 11px; font-weight: 600;
  letter-spacing: 0.08em; text-transform: uppercase;
  border-radius: var(--radius-sm); cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s, opacity 0.15s;
}
.btn-confirm:hover { opacity: 0.88; }
.btn-confirm.danger { background: var(--secondary); border-color: var(--secondary); }
.btn-confirm.danger:hover { opacity: 0.92; }
</style>
